import { render } from "./CommonTable2.vue?vue&type=template&id=7ca8033e&scoped=true"
import script from "./CommonTable2.vue?vue&type=script&lang=js"
export * from "./CommonTable2.vue?vue&type=script&lang=js"

import "./CommonTable2.vue?vue&type=style&index=0&id=7ca8033e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca8033e"]])

export default __exports__